import {Injectable} from '@angular/core';
import {Headers, Http, Response} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {AppSettings} from "../app.settings";
import {AgentUtility} from "../util/agent.utility";
import {Base2Service} from "./base2.service";
import {ResponseApi} from "./response/response";

@Injectable()
export class EventsService extends Base2Service {

    changeEventType(type): Observable<ResponseApi> {
        return this.request<ResponseApi>("PUT", AppSettings.apiUrl + 'events/types', type);
    }

    getEvents(filter: EventFilter): Observable<ResponseApi> {
        return this.request<ResponseApi>("POST", AppSettings.apiUrl + 'events', filter);
    }

    changeEvent(param): Observable<ResponseApi> {
        return this.request<ResponseApi>("PUT", AppSettings.apiUrl + 'events', param);
    }

    getTypesList(): Observable<ResponseApi> {
        return this.request<ResponseApi>("GET", AppSettings.apiUrl + 'events/types');
    }

    getPreparedData(eventArr: any){
        let countEventTodo = eventArr.length;
        let countEventDone = eventArr.filter((item) => {
            if (item.title === "Встреча") {
                return item.meta.data.Result || false;
            } else {
                return item.meta.data.IsViewed;
            }
        }).length;

        let percentEventDone = 0;
        if (countEventTodo != 0 && countEventDone != 0) {
            if (Math.round((countEventDone * 100) / countEventTodo) < 0)
                percentEventDone = Number.parseFloat(((countEventDone * 100) / countEventTodo).toFixed(2));
            else
                percentEventDone = Math.round((countEventDone * 100) / countEventTodo);
        }

        let agent = AgentUtility.getUser();
        return this.request<any>("GET", AppSettings.apiUrl + 'events/source/' + agent.Id).map((resp: any) => {
            return {
                countEventTodo: countEventTodo,
                countEventDone: countEventDone,
                percentEventDone: percentEventDone,
                countToday: resp.countToday,
                countWeek: resp.countWeek,
                countMonth: resp.countMonth,
                countYear: resp.countYear
            };
        });
    }


}

export class EventFilter {
    ContractId?: number;
    Number?: string;
    PersonId?: number;
    PolicyHolder?: string;
    EventDate?: Date;
    EventTypeId?: number;
    EventType?: string;
    AgentId?: number;
    IsViewed?: boolean;
    ViewedByAgentId?: number;
    limit?: any;
    excel?: boolean = false;
    page?: number;
    typeDate?: EventFilterDate;
    agents?: number[];
    ContractIds?: number[];
    deep:boolean = false;
    PersonsId?: number;
}

export class EventFilterChild {
    ContractId?: number;
    Number?: string;
    PersonId?: number;
    PolicyHolder?: string;
    EventDate?: Date;
    EventTypeId?: number;
    EventType?: string;
    AgentId?: number;
    IsViewed?: boolean;
    ViewedByAgentId?: number;
    limit?: any;
    excel?: boolean = false;
    page?: number;
    typeDate?: EventFilterDate;
    agents?: number[];
    ContractIds?: number[];
    deep:boolean = false;
    lastName?: string;
    firstName?: string;
    middleName?: string;
    AgentLastName?: string;
    AgentFirstName?: string;
    AgentMiddleName?: string;

}

export enum EventFilterDate {
    Today,
    Weekly,
    Month,
    Year
}

export enum EventType {
    Bithday = 1,
    NextPayment = 2,
    AnniversaryContract = 3,
    EndContract = 4
}